
import { Options, Vue } from 'vue-class-component'
import Farm from '@/farm/Farm'
import EmployeeCard from '@/components/EmployeeCard.vue'
import ValueMeter from '@/components/ui/ValueMeter.vue'
import Laboratory from '@/farm/Laboratory'
import ResearchCard from '@/components/ResearchCard.vue'
import Research from '@/Research'
import FarmStatusCard from '@/components/FarmStatusCard.vue'
import TextButton from '@/components/ui/TextButton.vue'
import util from '@/util'
import StatusBar from '@/components/StatusBar.vue'

@Options({
  components: {
    ResearchCard, ValueMeter, FarmStatusCard, TextButton, StatusBar
  },
  props: {
    farm: Object
  },
  methods: {
    log(msg: any) {
      console.log(msg)
    },
    selectResearch(research: Research) {
      this.selectedResearch = research.id
    },
    util() {
      return util
    }
  },
  emits: ['close'],
  computed: {
    lab: function () {
      return this.farm.state.lab
    }
  },
  async created() {
    this.selectedResearch = ''
    this.isLoaded = true
  },
  activated() {
    this.$forceUpdate() // Not sure if this is needed anymore
  }
})
export default class LabView extends Vue {
  isLoaded = false
  farm!: Farm
  selectedResearch: string = ''
}
